
class CouponSource {
    constructor(API) {
        this.API = API;
    }

     async selected() {
         return await this.API.get('/index.php?route=api/coupon')
     }
    async remove() {
        return await this.API.post('/index.php?route=api/coupon/clear')
    }
    async setCoupon(data) {
        return await this.API.post("/index.php?route=api/coupon/set", data)
    }
}

export default CouponSource
